import { Directive, OnDestroy } from '@angular/core';
import { FuncaoService, GlobalService, LoginContabil, Relatorio } from 'eddydata-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LdoService } from '../../../../planejamento/ldo/service/ldo.service';

@Directive()
export class Demo1Ldo implements OnDestroy {
  protected funcaoService: FuncaoService;
  private login: LoginContabil = new LoginContabil();
  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected ano: number,
    protected ldoServico: LdoService) {
    this.funcaoService = new FuncaoService();
    this.login = GlobalService.obterSessaoLogin();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public montarRelatorio() {
    this.ldoServico.filtrar({
      tipo: 'D10',
      'ppa.id': this.login.ppa.id,
      orderBy: 'linha'
    })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        Relatorio.imprimirPersonalizado(
          'DEMONSTRATIVO I - METAS ANUAIS'
          , this.login.usuario.nome,
          this.login.orgao.nome, this.login.brasao,
          this.conteudo(dados.content),
          'landscape', 'DEMONSTRATIVO I - LDO',
          {
            linhas: {
              hLineWidth() {
                return 1;
              },
              vLineWidth() {
                return 1;
              },
              hLineColor() {
                return 'black';
              },
              paddingLeft() {
                return 3;
              },
              paddingRight() {
                return 3;
              }
            }
          });
      });
  }

  private conteudo(dados1: any[]): {}[] {
    if (dados1.length === 0) {
      return;
    }
    const ano1 = +this.ano + 1;
    const ano2 = +this.ano + 2;
    const ano3 = +this.ano + 3;
    // monta o cabecalho
    const registros: {}[] = [
      [{
        text: `EXERCÍCIO: ${this.ano}`,
        alignment: 'center',
        bold: true, fontSize: 11,
        colSpan: 10, border: [false, false, false, false]
      }, '', '', '', '', '', '', '', '', ''],
      [{
        text: 'Lei nº 4.320/64, Art. 2º, §1º, II',
        alignment: 'center',
        bold: true,
        colSpan: 10, border: [false, false, false, false]
      }, '', '', '', '', '', '', '', '', ''],
      [{
        text: '',
        border: [true, true, true, false]
      }, {
        text: ano1, colSpan: 3, alignment: 'center',
        border: [true, true, true, false]
      },
      {
        text: '',
        border: [true, true, true, false]
      }, {
        text: '',
        border: [true, true, true, false]
      }, {
        text: ano2, colSpan: 3, alignment: 'center',
        border: [true, true, true, false]
      }, {
        text: '',
        border: [true, true, true, false]
      }, {
        text: '',
        border: [true, true, true, false]
      }, {
        text: ano3, colSpan: 3, alignment: 'center',
        border: [true, true, true, false]
      }, {
        text: '',
        border: [true, true, true, false]
      }, {
        text: '',
        border: [true, true, true, false]
      }],
      [{
        text: 'ESPECIFICAÇÃO',
        alignment: 'center',
        bold: true, fontSize: 8, border: [true, false, true, true]
      }, {
        text: 'Valor Corrente (a)',
        alignment: 'center',
        bold: true, fontSize: 8,
      }, {
        text: 'Valor Constante',
        alignment: 'center',
        bold: true, fontSize: 8
      }, {
        text: '% PIB (a/PIB x 100)',
        alignment: 'center',
        bold: true, fontSize: 8
      }, {
        text: 'Valor Corrente (b)',
        alignment: 'center',
        bold: true, fontSize: 8
      }, {
        text: 'Valor Constante',
        alignment: 'center',
        bold: true, fontSize: 8
      }, {
        text: '% PIB (a/PIB x 100)',
        alignment: 'center',
        bold: true, fontSize: 8
      }, {
        text: 'Valor Corrente (c)',
        alignment: 'center',
        bold: true, fontSize: 8
      }, {
        text: 'Valor Constante',
        alignment: 'center',
        bold: true, fontSize: 8
      }, {
        text: '% PIB (a/PIB x 100)',
        alignment: 'center',
        bold: true, fontSize: 8
      }]
    ];
    // monta relatório
    for (const item of dados1) {
      registros.push([
        {
          text: item.descricao1, fontSize: 8, border: [true, false, false, false],
        },
        {
          text: this.funcaoService.convertToBrNumber(item.valor1), alignment: 'right',
          fontSize: 8, border: [true, false, false, false]
        },
        {
          text: this.funcaoService.convertToBrNumber(item.valor2), alignment: 'right',
          fontSize: 8, border: [true, false, false, false]
        },
        {
          text: this.funcaoService.convertToBrNumber(item.valor3), alignment: 'right',
          fontSize: 8, border: [true, false, false, false]
        },
        {
          text: this.funcaoService.convertToBrNumber(item.valor4), alignment: 'right',
          fontSize: 8, border: [true, false, false, false]
        },
        {
          text: this.funcaoService.convertToBrNumber(item.valor5), alignment: 'right',
          fontSize: 8, border: [true, false, true, false]
        },
        {
          text: this.funcaoService.convertToBrNumber(item.valor5), alignment: 'right',
          fontSize: 8, border: [true, false, true, false]
        },
        {
          text: this.funcaoService.convertToBrNumber(item.valor5), alignment: 'right',
          fontSize: 8, border: [true, false, true, false]
        },
        {
          text: this.funcaoService.convertToBrNumber(item.valor5), alignment: 'right',
          fontSize: 8, border: [true, false, true, false]
        },
        {
          text: this.funcaoService.convertToBrNumber(item.valor5), alignment: 'right',
          fontSize: 8, border: [true, false, true, false]
        }
      ]);
    }
    registros.push([
      {
        text: '', border: [true, false, true, true], colSpan: 10
      }, '', '', '', '', '', '', '', '', ''
    ]);
    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        headerRows: 2,
        widths: ['*', 60, 60, 60, 60, 60, 60, 60, 60, 60],
        body: registros
      }
    }];

  }


}
